import { toast } from "react-toastify";
import { endpoints } from "../../configs/Settings";
import { useAxios } from "../../utils/useAxios";
import { HTTPResponseStatus } from "../../utils/enum";
import { getAuthToken } from "@/services/auth/OAuthApplication";

import { resolveNotificationPhoneNumberId } from "./notificationHelpers";
import type { INotificationData, SendNotificationOptions } from "./types";

/**
 * Serviço para envio de notificações via templates WhatsApp.
 */
export class NotificationService {
  private readonly templatesBaseUrl = `${endpoints.notification}/templates`;

  /**
   * Envia uma notificação usando o template especificado.
   * URL: `${endpoints.notification}/templates/${phoneNumberId}`
   */
  async sendNotification(
    data: INotificationData,
    options?: SendNotificationOptions,
  ) {
    try {
      const phoneNumberId = await resolveNotificationPhoneNumberId({
        organizationId: options?.organizationId,
        phoneNumberId: options?.phoneNumberId,
      });

      const apiUrl = `${this.templatesBaseUrl}/${encodeURIComponent(phoneNumberId)}`;

      const headers = {
        Authorization: await getAuthToken(),
        Accept: "*/*",
        "Content-Type": "application/json",
      };

      const response = await useAxios.post(apiUrl, data, {
        headers,
        timeout: 8000,
        withCredentials: false,
      });

      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`Erro no envio da notificação: ${response.status}`);
      }

      return response.data;
    } catch (error: any) {
      console.error("NotificationService.sendNotification:", error);

      if (error.response?.status === 400) {
        const errorMessage = error.response?.data?.error?.message;
        if (errorMessage) {
          toast.error(errorMessage);
        } else {
          toast.error(
            "Erro ao enviar notificação, tente novamente em instantes!",
          );
        }
      } else if (error instanceof Error && error.message.includes("phoneNumberId")) {
        toast.error(error.message);
      } else if (error instanceof Error && error.message.includes("organização")) {
        toast.error(error.message);
      } else {
        toast.error("Erro ao enviar notificação");
      }

      throw error;
    }
  }
}

export const notificationService = new NotificationService();
